export const loginURL = '/login';
export const homeURL = '/';
export const accountsURL = '/accounts';
export const overviewURL = '/overview';
export const profileURL = '/profile';
export const budgetURL = '/budget';
export const depositsURL = '/deposits';
// export const resourcesURL = '/resources';
export const passwordResetURL = '/passwordreset/:passwordToken';
export const unsubscribeEmailURL = '/:username/unsubscribe/email';
export const passwordHelpURL = '/passwordhelp';
export const impersonateURL = '/impersonate/:contactID';
export const scheduleURL = '/schedule/:teamId';
export const contactUsURL = '/contactus';


// WEBPACK FOOTER //
// ./src/shared/urls/app.js